import { ModalPlugin } from "bootstrap-vue";
import Vue from "vue";

Vue.use(ModalPlugin);
